module.exports = __webpack_public_path__ + "static/media/portfolio-title-3.cb022e67.svg";